<div class="filter-bar">
  <div>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Search Users</mat-label>

      <input type="text" matInput (keyup)="applyFilter($event)">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>


    <mat-checkbox [(ngModel)]="checked" (change)="updatePendingFilter()">
      Only Show Accounts Pending Approval
    </mat-checkbox>
  </div>

  <button mat-flat-button color="primary" (click)="exportToCsv()">
    Export to CSV
  </button>


</div>

<ng-container>
  <mat-card class="table">
    <mat-card-content>
      <div class="mat-elevation-z8">
        <table mat-table
               matSort
               matSortActive="firstName"
               matSortDirection="asc"
               matSortDisableClear
               [dataSource]="dataSource">

          <ng-container matColumnDef="firstName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> First Name</th>
            <td mat-cell *matCellDef="let element"> {{ element.firstName }}</td>
          </ng-container>

          <ng-container matColumnDef="lastName">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Last Name</th>
            <td mat-cell *matCellDef="let element"> {{ element.lastName }}</td>
          </ng-container>

          <ng-container matColumnDef="email">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Email</th>
            <td mat-cell *matCellDef="let element"> {{ element.email }}</td>
          </ng-container>

          <ng-container matColumnDef="username">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Username</th>
            <td mat-cell *matCellDef="let element"> {{ element.username }}</td>
          </ng-container>

          <ng-container matColumnDef="organization">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Organization</th>
            <td mat-cell *matCellDef="let element"> {{ element.organization }}</td>
          </ng-container>

          <ng-container matColumnDef="joinDate">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Joined Date</th>
            <td mat-cell *matCellDef="let element"> {{ element.joinDate | date: 'short' }}</td>
          </ng-container>

          <ng-container matColumnDef="lastLoginDate">
            <th mat-header-cell mat-sort-header *matHeaderCellDef> Last Login Date</th>
            <td mat-cell *matCellDef="let element"> {{ element.lastLoginDate | date: 'short' }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row class="hoverable" (click)="navToUser(row)" *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>

        <mat-paginator [pageSizeOptions]="[25, 50, 75, 100]"
                       showFirstLastButtons>
        </mat-paginator>
      </div>

    </mat-card-content>
  </mat-card>
</ng-container>
